/* eslint-disable arrow-parens */
import { useState, useCallback, useEffect, useContext, useRef, Suspense } from "react";
import { useNavigate } from "react-router-dom";
import {
	Paper,
	Select,
	MenuItem,
	Grid,
	Button,
	TextField,
	InputAdornment,
	Tooltip,
	Checkbox,
	CheckboxProps
} from "@material-ui/core";
import { withStyles, Theme } from "@material-ui/core/styles";
import { ADMIN_DASHBOARD_HEADER } from "../../../../../../../../../../constants/caption/dashboardHeader";
import { AuthContext, UIContext } from "../../../../../../../../../../contexts";
import GENDERS from "../../../../../../../../../../constants/genders";
import { MARITAL_STATUSES } from "../../../../../../../../../../constants/maritalStatus";
import initCapitalize from "../../../../../../../../../../utils/commonFunctions/initCapitalize";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import "date-fns";
import { DynamicForm } from "../../../../../../../../../../@types/dynamicForm.types";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import useRouteParam from "../../../../../../../../../../hooks/useRouteParam";
import { trackPromise } from "react-promise-tracker";
import { api } from "../../../../../../../../../../utils/api";
import ROLES from "../../../../../../../../../../constants/roles";
import { green } from "@material-ui/core/colors";
import { infoTitleMessage } from "../../../../../../../../../../constants/infoTitleMessage";
import { ConditionPosition } from "ag-grid-community/dist/lib/filter/provided/simpleFilter";
import { Validation } from "../../../../../../../../../../@types/validation.types";
import { LazySnackbarAPI } from "../../../../../../../../../shared";
import ExtractRouteParams from "../../../../../../../../../../utils/commonFunctions/extractRouteParams";
import { SnackbarProps } from "../../../../../../../../../../@types/snackbarAPI.types";
import SnackbarAPICall from "../../../../../../../../../shared/snackbar/SnackbarAPICall";

import SendIcon from "@material-ui/icons/Send";
import ReplyIcon from "@material-ui/icons/Reply";
import EventIcon from "@material-ui/icons/Event";
import InfoIcon from "@material-ui/icons/Info";

import "../../../../../../../../../../globalStyles/paperFormStyles.css";
import { Member } from "../../../../../../../../../../@types/member.types";
import { RELATIONSHIP, RELATIONSHIPS } from "../../../../../../../../../../constants/relationships";
import DEPENDENT_TYPES from "../../../../../../../../../../constants/dependentTypes";
import {
	dateTimeZoneDOBConverter,
	dateTimeZoneMaterialUIConverter
} from "../../../../../../../../../../utils/commonFunctions/date";
import { handleSSNFormat } from "../../../../../../../../../../utils/commonFunctions/SSN";

const LightTooltip = withStyles((theme: Theme) => ({
	tooltip: {
		backgroundColor: "#f5f5f9",
		color: "rgba(0, 0, 0, 0.87)",
		boxShadow: theme.shadows[1],
		maxWidth: 130,
		fontSize: 11
	}
}))(Tooltip);

const GreenCheckbox = withStyles({
	root: {
		color: green[400],
		"&$checked": {
			color: green[600]
		}
	},
	checked: {}
})((props: CheckboxProps) => <Checkbox color="default" {...props} />);

const EditDependentProfileInformation = (): JSX.Element => {
	const querySSN = useRouteParam("qs");
	const queryGroupNumber = useRouteParam("gn");
	const [editProfileForm, setEditProfileForm] = useState<DynamicForm>();
	const [employee, setEmployee] = useState<any>({
		member_id: "",
		employee_number: null,
		first_name: "",
		last_name: "",
		SSN: ""
	});
	const [dependent, setDependent] = useState<any>({
		dependent_number: null,
		first_name: "",
		middle_name: "",
		last_name: "",
		email: "",
		SSN: "",
		date_of_birth: "",
		gender: "",
		dependent_type: "",
		relationship: "",
		upload_type: "",
		dependent_status: "",
		is_tobacco: false,
		is_disabled: false,
		dependent_profile_access: false
	});
	const { setDashboardHeader } = useContext(UIContext);
	const [dependentMongoID, setDependentMongoID] = useState<string>("");
	const [hasEditProfileSubmitClick, setHasEditProfileSubmitClick] = useState(false);
	const [allDependents, setAllDependents] = useState<any[]>([]);
	const navigate = useNavigate();
	const [validation, setValidation] = useState<Validation>({
		dependent: {},
		status: "invalid"
	});
	const _validation = useRef<Validation>();
	const routeParam = ExtractRouteParams(); // This is to extract the route after ?(Question Mark)
	const [snackbarAPICallProps, setSnackbarAPICallProps] = useState<SnackbarProps>({
		open: false,
		severity: undefined,
		message: "",
		handleSnackbarClose: (event, reason) => {
			if (reason === "clickaway") return;
			setSnackbarAPICallProps(
				Object.assign({}, snackbarAPICallProps, {
					open: false
				})
			);
		}
	});
	const { user } = useContext(AuthContext);

	const handleValidation = useCallback(async () => {
		const { first_name, last_name, date_of_birth, gender, relationship } = dependent;
		_validation.current = {
			...validation,
			dependent: {},
			status: "invalid"
		};
		let flag = true;

		// dependent validation checking

		if (first_name.length === 0) {
			_validation.current.dependent["first_name"] = "First Name is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (last_name.length === 0) {
			_validation.current.dependent["last_name"] = "Last Name is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (String(date_of_birth).length === 0) {
			_validation.current.dependent["date_of_birth"] = "Date of birth is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (gender.length === 0) {
			_validation.current.dependent["gender"] = "Gender is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (relationship.length === 0) {
			_validation.current.dependent["relationship"] = "Relationship is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}

		if (flag === true) _validation.current["status"] = "valid";
		else {
			_validation.current["status"] = "invalid";
			alert("Please, fill all required fields!");
		}
		setValidation(Object.assign({}, _validation.current));
		return _validation.current["status"];
	}, [dependent, validation]);

	// const handleDependentDateChange = useCallback(
	// 	(_date: MaterialUiPickersDate, name: string) => {
	// 		const date = new Date(_date as Date);
	// 		const parsedDate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
	// 		setDependent(Object.assign({}, dependent, { [name]: parsedDate }));
	// 	},
	// 	[dependent]
	// );

	const handleDependentDateChange = useCallback(
		(_date: MaterialUiPickersDate, name: string) => {
			const parsedDate = _date as unknown as string;
			setDependent(Object.assign({}, dependent, { [name]: parsedDate }));
		},
		[dependent]
	);

	const handleDependentInformationChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const { name } = event.target;
			let { value } = event.target;

			const spouseAlreadyExists = allDependents.some(
				(dep) => dep.relationship === RELATIONSHIP.spouse && dep._id !== dependentMongoID
			);

			if (name === "relationship" && value === RELATIONSHIP.spouse) {
				if (spouseAlreadyExists) {
					alert("Spouse already exists for this employee.");
					return;
				}
			}

			if (name === "first_name") {
				const regex = /^[a-zA-Z]+$/;
				if (value.match(regex) || value === "") {
					value = value.slice(0, 1).toUpperCase() + value.slice(1);
					setDependent(Object.assign({}, dependent, { [name]: value }));
				} else if (/\s/g.test(value)) {
					setDependent(Object.assign({}, dependent, { [name]: value }));
				}
			} else setDependent(Object.assign({}, dependent, { [name]: value }));
		},
		[dependent, allDependents, dependentMongoID]
	);

	const getDependentBySSNWithEmployee = useCallback(async (SSN: string, group_number: number) => {
		const findDependentWithEmployeeQuery = {
			group_number,
			SSN
		};

		const members = await trackPromise(api.member.getDependentBySSNWithEmployee(findDependentWithEmployeeQuery));
		if (members) {
			// console.log("debug=====> 1111", members);
			const { employeeInstance, dependentInstance, allDependentsInstance } = members;
			setAllDependents(allDependentsInstance || []);
			// console.log("debug=====> 2222", employeeInstance, dependentInstance, allDependents);
			if (employeeInstance) {
				const { member_id, first_name, last_name, employee_number, SSN } = employeeInstance;
				const _employeeInstance = {
					member_id,
					employee_number,
					first_name,
					last_name,
					SSN
				};
				setEmployee(Object.assign({}, _employeeInstance));
			}

			// console.log("dependent instance from mongodb", dependentInstance);
			if (dependentInstance) {
				const {
					_id,
					dependent_number,
					first_name,
					middle_name,
					last_name,
					email,
					SSN,
					date_of_birth,
					gender,
					relationship,
					dependent_type,
					upload_type,
					dependent_status,
					is_tobacco,
					is_disabled,
					dependent_profile_access
				} = dependentInstance;

				setDependentMongoID(_id as string);

				const _dependentInstance = {
					dependent_number,
					first_name,
					middle_name,
					last_name,
					email,
					SSN,
					date_of_birth: dateTimeZoneDOBConverter(date_of_birth),
					gender,
					relationship,
					dependent_type,
					upload_type,
					dependent_status,
					is_tobacco,
					is_disabled,
					dependent_profile_access
				};
				setDependent(Object.assign({}, _dependentInstance));
			}
		}
	}, []);

	const handleRedirectToDependentDetails = useCallback(() => {
		const pathname = `/employer/member/dependent?${routeParam}`;
		navigate(pathname);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleEditProfileSubmitClick = useCallback(
		async (event: React.MouseEvent<HTMLButtonElement>) => {
			try {
				event.preventDefault();
				const validation = await handleValidation();
				if (validation === "valid") {
					const { date_of_birth } = dependent;
					const DOB = new Date(date_of_birth);

					// console.log("in the handle submit click", dependent);

					const payload: Member = {
						...dependent,
						date_of_birth: DOB.getFullYear() + "-" + (DOB.getMonth() + 1) + "-" + DOB.getDate()
					};

					// console.log("Payload", payload);
					const response: Member = await trackPromise(
						api.member.editDependentProfileInformationById(payload, dependentMongoID as string)
					);

					if (response) {
						setHasEditProfileSubmitClick(true);
						// console.log("Response", response);

						setSnackbarAPICallProps(
							Object.assign({}, snackbarAPICallProps, {
								open: true,
								message: "Dependent Profile Edited Successfully!",
								severity: "success"
							})
						);

						// alert("Edit Dependent Profile Submission Successfully!");

						setTimeout(() => {
							handleRedirectToDependentDetails();
						}, 2000);
					}
				} else {
					setHasEditProfileSubmitClick(false);
				}
			} catch (error) {
				setHasEditProfileSubmitClick(false);
				alert("Dependent Profile Edit unsuccessful!");
				throw error;
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[dependent, handleValidation, snackbarAPICallProps]
	);

	const handleEnableCheckbox = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const { name, checked } = event.target;
			setDependent(Object.assign({}, dependent, { [name]: checked }));
		},
		[dependent]
	);

	useEffect(() => {
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.edit_dependent_profile);
	}, [setDashboardHeader]);

	useEffect(() => {
		if (querySSN && queryGroupNumber) getDependentBySSNWithEmployee(querySSN as string, queryGroupNumber as number);
	}, [getDependentBySSNWithEmployee, querySSN, queryGroupNumber]);

	useEffect(() => {
		setEditProfileForm(
			Object.assign(
				{},
				{
					"Employee Information": [
						{
							schema: "employee",
							label: "Employee Id",
							name: "member_id",
							onChange: () => null,
							value: employee.member_id,
							type: "textfield"
						},
						{
							schema: "employee",
							label: "WLT Employee Number",
							name: "employee_number",
							onChange: () => null,
							value: employee.employee_number,
							type: "textfield"
						},
						{
							schema: "employee",
							label: "First Name",
							name: "first_name",
							value: employee.first_name,
							onChange: () => null,
							type: "textfield"
						},
						{
							schema: "employee",
							label: "Last Name",
							name: "last_name",
							value: employee.last_name,
							onChange: () => null,
							type: "textfield"
						},
						{
							schema: "employee",
							label: "SSN / ALt Id",
							name: "SSN",
							onChange: () => null,
							value: handleSSNFormat(user, employee.SSN),
							type: "textfield"
						}
					],
					"Dependent Profile Information": [
						{
							schema: "dependent",
							label: "WLT Dependent number",
							name: "dependent_number",
							onChange: () => null,
							value: dependent.dependent_number,
							type: "textfield"
						},
						{
							schema: "dependent",
							label: "First Name",
							name: "first_name",
							value: dependent.first_name,
							onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
								handleDependentInformationChange(event),
							type: "textfield"
						},
						{
							schema: "dependent",
							label: "Middle Name",
							name: "middle_name",
							value: dependent.middle_name,
							onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
								handleDependentInformationChange(event),
							type: "textfield"
						},
						{
							schema: "dependent",
							label: "Last Name",
							name: "last_name",
							value: dependent.last_name,
							onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
								handleDependentInformationChange(event),
							type: "textfield"
						},
						{
							schema: "dependent",
							label: "Email",
							name: "email",
							onChange: () => null,
							value: dependent.email,
							type: "textfield"
						},
						{
							schema: "dependent",
							label: "SSN",
							name: "SSN",
							onChange: () => null,
							value: handleSSNFormat(user, dependent.SSN),
							type: "textfield"
						},
						{
							schema: "dependent",
							label: "Date Of Birth",
							name: "date_of_birth",
							value: dependent.date_of_birth,
							onChange: (date: MaterialUiPickersDate, name: string) =>
								handleDependentDateChange(date, name),
							type: "date"
						},
						{
							schema: "dependent",
							label: "Gender",
							name: "gender",
							value: dependent.gender,
							onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
								handleDependentInformationChange(event),
							type: "select",
							options: GENDERS
						},
						{
							schema: "dependent",
							label: "Relationship",
							name: "relationship",
							value: dependent.relationship,
							onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
								handleDependentInformationChange(event),
							type: "select",
							options: RELATIONSHIPS
						},
						{
							schema: "dependent",
							label: "Dependent Type",
							name: "dependent_type",
							value: dependent.dependent_type,
							onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
								handleDependentInformationChange(event),
							type: "select",
							options: DEPENDENT_TYPES
						},
						{
							schema: "dependent",
							label: "Upload Type",
							name: "upload_type",
							onChange: () => null,
							value: dependent.upload_type,
							type: "textfield"
						},
						{
							schema: "dependent",
							label: "Dependent Status",
							name: "dependent_status",
							onChange: () => null,
							value: dependent.dependent_status,
							type: "textfield"
						},
						{
							schema: "dependent",
							label: "Disabled",
							name: "is_disabled",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleEnableCheckbox(event),
							value: dependent.is_disabled,
							type: "checkbox"
						},
						{
							schema: "dependent",
							label: "Tobacco",
							name: "is_tobacco",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleEnableCheckbox(event),
							value: dependent.is_tobacco,
							type: "checkbox"
						},
						{
							schema: "dependent",
							label: "Dependent Profile Access",
							name: "dependent_profile_access",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleEnableCheckbox(event),
							value: dependent.dependent_profile_access,
							type: "checkbox"
						}
					]
				}
			)
		);
	}, [employee, dependent, handleDependentInformationChange, handleDependentDateChange, user, handleEnableCheckbox]);

	// console.log("Employee", employee);
	// console.log("Dependent", dependent);

	// console.log("DependentMongoID", dependentMongoID);

	return (
		<div className="edit-profile-information-container">
			<Suspense fallback={<div />}>
				<SnackbarAPICall snackbarProps={snackbarAPICallProps} />
			</Suspense>
			<div className="pf-action-button-container" id="pf-action-button-container">
				<Button
					className="button-green"
					onClick={handleEditProfileSubmitClick}
					variant="contained"
					disabled={hasEditProfileSubmitClick}
					style={{
						cursor: hasEditProfileSubmitClick ? "not-allowed" : "pointer",
						pointerEvents: "unset"
					}}
				>
					<span className="button-label-with-icon">Submit</span>
					<span>
						<SendIcon className="button-icon" />
					</span>
				</Button>
			</div>
			<Grid container spacing={1} className="pf-grid-container">
				{editProfileForm &&
					Object.entries(editProfileForm).map(([key, value], index) => {
						return (
							<div key={index}>
								<div className="pf-title">{key}</div>
								<Paper className="pf-paper-container" variant="outlined" elevation={3}>
									{value.map((field, index) => {
										const { schema, name, label, value, type, onChange } = field;
										return (
											<Grid item key={index} xl={12} lg={12} md={12} sm={12} xs={12}>
												<Grid container spacing={1} className="pf-label">
													<Grid
														item
														xs={
															field.name === "is_tobacco" ||
															field.name === "is_disabled" ||
															field.name === "dependent_profile_access"
																? undefined
																: 12
														}
														sm={
															field.name === "is_tobacco" ||
															field.name === "is_disabled" ||
															field.name === "dependent_profile_access"
																? undefined
																: 12
														}
														md={
															field.name === "is_tobacco" ||
															field.name === "is_disabled" ||
															field.name === "dependent_profile_access"
																? undefined
																: 3
														}
														lg={
															field.name === "is_tobacco" ||
															field.name === "is_disabled" ||
															field.name === "dependent_profile_access"
																? undefined
																: 3
														}
														xl={
															field.name === "is_tobacco" ||
															field.name === "is_disabled" ||
															field.name === "dependent_profile_access"
																? undefined
																: 3
														}
													>
														<div className="pf-label-text" id="pf-label-text">
															{field.name === "is_tobacco" ||
															field.name === "is_disabled" ||
															field.name === "dependent_profile_access"
																? ""
																: field.label}
														</div>
													</Grid>
													<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
														{type === "textfield" ? (
															<TextField
																className="input-text-field"
																id={
																	schema === "employee"
																		? "disabled-input-text-field"
																		: schema === "dependent"
																		? name === "dependent_number" ||
																		  name === "email" ||
																		  name === "SSN" ||
																		  name === "upload_type" ||
																		  name === "dependent_status"
																			? "disabled-input-text-field"
																			: "input-text-field"
																		: "input-text-field"
																}
																value={
																	name === "upload_type"
																		? value
																			? initCapitalize(value as string)
																			: value
																		: name === "dependent_status"
																		? value
																			? initCapitalize(value as string)
																			: value
																		: value
																}
																name={name}
																onChange={onChange}
																variant="outlined"
																disabled={
																	schema === "employee"
																		? true
																		: schema === "dependent"
																		? name === "dependent_number" ||
																		  name === "email" ||
																		  name === "SSN" ||
																		  name === "upload_type" ||
																		  name === "dependent_status"
																			? true
																			: false
																		: false
																}
																InputProps={{
																	endAdornment: (
																		<>
																			{schema === "employee" ? (
																				<InputAdornment position="end">
																					<LightTooltip
																						title={
																							name === "employee_number"
																								? infoTitleMessage.employee_number
																								: name === "member_id"
																								? infoTitleMessage.member_id
																								: name === "SSN"
																								? infoTitleMessage.SSN
																								: name === "first_name"
																								? infoTitleMessage.first_name
																								: name === "last_name"
																								? infoTitleMessage.last_name
																								: ""
																						}
																						placement="right-start"
																						arrow
																					>
																						<InfoIcon
																							style={{
																								color: "#808080",
																								fontSize: "20px",
																								// cursor: !showSaveButton
																								// 	? "default"
																								// 	: "pointer",
																								pointerEvents: "unset"
																							}}
																						/>
																					</LightTooltip>
																				</InputAdornment>
																			) : schema === "dependent" ? (
																				name === "dependent_number" ||
																				name === "email" ||
																				name === "SSN" ||
																				name === "upload_type" ||
																				name === "dependent_status" ? (
																					<InputAdornment position="end">
																						<LightTooltip
																							title={
																								name ===
																								"dependent_number"
																									? infoTitleMessage.dependent_number
																									: name === "email"
																									? infoTitleMessage.email
																									: name === "SSN"
																									? infoTitleMessage.SSN
																									: name ===
																									  "upload_type"
																									? infoTitleMessage.upload_type
																									: name ===
																									  "dependent_status"
																									? infoTitleMessage.dependent_status
																									: ""
																							}
																							placement="right-start"
																							arrow
																						>
																							<InfoIcon
																								style={{
																									color: "#808080",
																									fontSize: "20px",
																									// cursor: !showSaveButton
																									// 	? "default"
																									// 	: "pointer",
																									pointerEvents:
																										"unset"
																								}}
																							/>
																						</LightTooltip>
																					</InputAdornment>
																				) : null
																			) : null}
																		</>
																	),
																	readOnly:
																		schema === "employee"
																			? true
																			: schema === "dependent"
																			? name === "dependent_number" ||
																			  name === "email" ||
																			  name === "SSN" ||
																			  name === "upload_type" ||
																			  name === "dependent_status"
																				? true
																				: false
																			: false
																}}
																helperText={validation.dependent[name]}
																style={{
																	pointerEvents: "unset",
																	width: "340px",
																	borderRadius: 50
																}}
															/>
														) : type === "select" ? (
															<>
																<Select
																	id="text-align-options"
																	name={name}
																	value={value}
																	onChange={onChange}
																	style={{
																		pointerEvents: "unset",
																		minWidth: 180,
																		textAlign: "left",
																		overflowY: "visible"
																	}}
																	MenuProps={{
																		style: { zIndex: 35960 }
																	}}
																	inputProps={{ "aria-label": "Without label" }}
																>
																	<MenuItem value="" disabled>
																		Select Value
																	</MenuItem>
																	{field?.options?.map((option) => {
																		return (
																			<MenuItem key={option} value={option}>
																				{name !== "dependent_type"
																					? option
																						? initCapitalize(
																								option as string
																						  )
																						: option
																					: option}
																			</MenuItem>
																		);
																	})}
																</Select>
																{validation && validation.dependent[name] ? (
																	<div className="details">
																		<span className="select-validation-text2">
																			{field.schema === "dependent"
																				? validation.dependent[name]
																				: ""}
																		</span>
																	</div>
																) : null}
															</>
														) : type === "date" ? (
															<MuiPickersUtilsProvider utils={DateFnsUtils}>
																<KeyboardDatePicker
																	className="from-date-input"
																	id="from-date-input"
																	inputVariant="outlined"
																	label={label}
																	name={name}
																	format="MM/dd/yyyy"
																	error={false}
																	value={value}
																	onChange={(date: MaterialUiPickersDate) =>
																		onChange(date, name)
																	}
																	InputProps={{
																		readOnly: true
																	}}
																	InputLabelProps={{
																		shrink: true
																	}}
																	keyboardIcon={
																		<EventIcon
																			style={{
																				color: "#7cb342"
																			}}
																		/>
																	}
																	KeyboardButtonProps={{
																		"aria-label": "change date"
																	}}
																	style={{
																		pointerEvents: "unset",
																		width: "340px",
																		borderRadius: 50
																	}}
																	helperText={validation.dependent[name]}
																/>
															</MuiPickersUtilsProvider>
														) : type === "checkbox" ? (
															<>
																<div className="check-support" id="check-support">
																	<span>
																		<GreenCheckbox
																			onChange={field.onChange}
																			name={field.name}
																			checked={field.value}
																		/>
																	</span>
																	<span className="pf-label-text" id="pf-label-text">
																		{field.label}
																	</span>
																</div>
															</>
														) : null}
													</Grid>
												</Grid>
											</Grid>
										);
									})}
								</Paper>
							</div>
						);
					})}
			</Grid>
			<div className="pf-action-button-container margin-top-action-button" id="pf-action-button-container">
				<Button
					className="button-green"
					onClick={handleEditProfileSubmitClick}
					variant="contained"
					disabled={hasEditProfileSubmitClick}
					style={{
						cursor: hasEditProfileSubmitClick ? "not-allowed" : "pointer",
						pointerEvents: "unset"
					}}
				>
					<span className="button-label-with-icon">Submit</span>
					<span>
						<SendIcon className="button-icon" />
					</span>
				</Button>
			</div>
		</div>
	);
};

export default EditDependentProfileInformation;
